module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
         name: "Vouchers",
         path: "reports/vouchers",
         component: () => import('./vouchers/vouchers.vue'),
      },
      {
         name: "VoucherCard",
         path: "reports/voucher_card",
         component: () => import('./voucher_card/voucher_card.vue'),
      },
      {
         name: "Vouchers-View",
         path: "reports/view-voucher/:id",
         component: () => import('./voucher_card/view-voucher-cards.vue'),
      },
      {
         name: "Customer",
         path: "reports/customer",
         component: () => import('./customer/customer.vue'),
      },
      {
         name: "PromotionCoupon-View_Redemptions",
         path: "reports/promotion-coupons/:id",
         component: () => import('./promotion_coupon_redemption/promotion_coupon_redemption.vue'),
      },
      {
         name: "RewardRule-View_Coupons",
         path: "reports/rule-coupons/:id",
         component: () => import('./coupon/coupon.vue'),
      },
      {
         name: "Customer-View",
         path: "customers/view-customer/:id",
         component: () => import('./referal_reports/referal_reports.vue'),
      },
   ]
}